import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider } from './contexts/AuthContext';
import { ObsProvider }  from './contexts/ObsContext';
import ProtectedRoute   from './components/ProtectedRoute';
import PendingDebriefsPage from './pages/PendingDebriefsPage';
import AdminPage from './pages/admin/AdminPage';
import AdminObservationsPage from './pages/admin/AdminObservationsPage';
import AdminDashboardsPage   from './pages/admin/AdminDashboardsPage';
import AdminExportsPage      from './pages/admin/AdminExportsPage';

// Pages
import LoginPage      from './pages/LoginPage';
import HomePage       from './pages/HomePage';
import HistoryPage    from './pages/history/HistoryPage';
import DashboardPage  from './pages/dashboard/DashboardPage';
import ReconcilePage   from './pages/observation/ReconcilePage';
import ContextPage    from './pages/observation/ContextPage';
import EvidencePage   from './pages/observation/EvidencePage';
import ConclusionsPage from './pages/observation/ConclusionsPage';
import LeveragePage   from './pages/observation/LeveragePage';
import DebriefPage    from './pages/observation/DebriefPage';
import { FeedbackSendPage, FeedbackSentPage } from './pages/observation/FeedbackPages';

function App() {
  return (
    <AuthProvider>
      <ObsProvider>
        <BrowserRouter>
          {/* Toast Container */}
          <ToastContainer
            position="top-right"
            autoClose={3000}
          />
          {/* Mobile-like app frame */}
          <div className="app-shell">
            <div className="app-frame">
              <Routes>
                {/* Public */}
                <Route path="/login" element={<LoginPage />} />

                {/* Protected */}
                <Route path="/" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
                <Route path="/history"   element={<ProtectedRoute requires="view_own_history"><HistoryPage /></ProtectedRoute>} />
                <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
                <Route path="/debriefs"  element={<ProtectedRoute requires="debrief_feedback"><PendingDebriefsPage /></ProtectedRoute>} />
                <Route path="/admin"     element={<ProtectedRoute requires="manage_users"><AdminPage /></ProtectedRoute>} />
                <Route path="/observations" element={<ProtectedRoute requires="all_school_observations"><AdminObservationsPage /></ProtectedRoute>} />
                <Route path="/dashboards"   element={<ProtectedRoute requires="school_dashboard"><AdminDashboardsPage /></ProtectedRoute>} />
                <Route path="/exports"      element={<ProtectedRoute requires="growth_data_export"><AdminExportsPage /></ProtectedRoute>} />

                {/* Observation flow */}
                <Route path="/observe/context"     element={<ProtectedRoute requires="start_observation"><ContextPage /></ProtectedRoute>} />
                <Route path="/observe/evidence"    element={<ProtectedRoute requires="start_observation"><EvidencePage /></ProtectedRoute>} />
                <Route path="/observe/reconcile"   element={<ProtectedRoute requires="start_observation"><ReconcilePage /></ProtectedRoute>} />
                <Route path="/observe/conclusions" element={<ProtectedRoute requires="start_observation"><ConclusionsPage /></ProtectedRoute>} />
                <Route path="/observe/leverage"    element={<ProtectedRoute requires="debrief_feedback"><LeveragePage /></ProtectedRoute>} />
                <Route path="/observe/debrief"     element={<ProtectedRoute requires="debrief_feedback"><DebriefPage /></ProtectedRoute>} />
                <Route path="/observe/feedback"    element={<ProtectedRoute requires="debrief_feedback"><FeedbackSendPage /></ProtectedRoute>} />
                <Route path="/observe/sent"        element={<ProtectedRoute requires="debrief_feedback"><FeedbackSentPage /></ProtectedRoute>} />

                {/* Fallback */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
          </div>
        </BrowserRouter>
      </ObsProvider>
    </AuthProvider>
  );
}

export default App;
